import { lazy } from 'react';


export const Vacancies = lazy(() => import('./Vacancies'));
